module.exports = __webpack_public_path__ + "static/media/navbar-img-1.44288a96.jpg";